module.exports = __webpack_public_path__ + "static/media/IMG-20181023-WA0003-1.1c2ebef3.jpg";